"use client"

import { useAuthStore } from "@/lib/auth-store"
import { LogViewer } from "@/components/log-viewer"

/**
 * Floating Debug Logs menu. Shown to the owner (super_admin) and to any account the owner has granted
 * `profiles.dev_menu_access` (Admin -> Users -> "Give dev menu access"). Everyone else never renders it.
 * The flag is also locked in the database, so it can't be self-granted.
 */
export function DevMenu() {
  const allowed = useAuthStore((s) => s.profile?.role === "super_admin" || (s.profile as { dev_menu_access?: boolean } | null)?.dev_menu_access === true)
  if (!allowed) return null
  return <LogViewer side="left" />
}
